import { Component } from 'vue';

enum Routes {
	OVERVIEW = 'overview',
	SELECTED_DASHBOARD = 'selected-dashboard'
}

interface IRouter {
	current: Routes;
	next: Routes | null;
	props: {
		id: string;
	};
}

type TRoutes = {
	[key in Routes]: Component;
};

export { IRouter, TRoutes, Routes };
